import React, {useState} from 'react';
import {Container} from 'react-bootstrap';
import {InstructionModel} from "./InstructionModel";
import {createOrUpdatePropertyInstruction} from "../service/PropertyService";
import {FaBook, FaCar, FaLock, FaListAlt} from "react-icons/fa";
import PropertyJobsModal from './PropertyJobsModal';

export default function PropertyExpand(props) {
    const {property} = props;
    const [show, setShow] = useState(false);
    const [modelType, setModelType] = useState();
    const handleClose = () => setShow(false);
    
    const [showJobsModal, setShowJobsModal] = useState(false);
    const handleJobsModalClose = () => setShowJobsModal(false);
    const handleJobsModalShow = () => setShowJobsModal(true);

    const handleAddButton = (title) => {
        setModelType(title)
        setShow(true)
    };

    const handleSave = (property, instruction, modelType) => {
        let payload = {
            ...property,
            description: instruction.description,
            id: instruction.id,
            image_ids: instruction.images.map(image => image.id)
        }
        createOrUpdatePropertyInstruction(payload, modelType.toLowerCase()).then(response => {
            if (response.status === 200) {
                console.log("Instruction saved successfully")
                handleClose()
            } else {
                console.log("Instruction save failed")
            }
        })
    }


    return (<div style={{borderWidth: "1", borderColor: "lightgrey", width: "100%"}}>
        <Container fluid>
            <div style={{
                display: 'flex', justifyContent: 'start', alignItems: 'center', flexDirection: 'row'
            }}>
                <FaCar className="icon-button" size={22}
                       title={"CarPark Instructions"}
                       onClick={() => handleAddButton('CarPark')}
                />
                <FaLock size={22} className="icon-button"
                        title={"Locker Instructions"}
                        onClick={() => handleAddButton('Locker')}
                />
                <FaBook size={22} className="icon-button"
                        onClick={() => handleAddButton('Other')}
                        title={"Other Instructions"}/>
                <FaListAlt size={22} className="icon-button"
                        onClick={handleJobsModalShow}
                        title={"Recent Jobs"}/>
            </div>
        </Container>
        {show && <InstructionModel show={show}
                                   modelType={modelType}
                                   property={property}
                                   handleSave={handleSave}
                                   handleClose={handleClose}/>}
        <PropertyJobsModal 
            show={showJobsModal} 
            handleClose={handleJobsModalClose} 
            property={property} 
        />
    </div>);
}
